module.exports = __webpack_public_path__ + "static/media/daphne-win.e577e02b.png";